<template>
    <div class="">
        <el-form :model="account" label-width="200px" :rules="rules" ref="accountForm" class="supplier-form">
            <el-form-item label="供应商单位名称：" prop="fnameL2"><el-input type="text" v-model.trim="account.fnameL2" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="业务对接人姓名：" prop="fcallname"><el-input type="text" v-model.trim="account.fcallname" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="业务对接人手机号码：" prop="fphone"><el-input type="tel" v-model="account.fphone" :maxlength="11" style="width:396px;float:left;margin-right: 48px;" auto-complete="off"></el-input><el-button type="primary" @click="sendCode">{{countDown}}</el-button></el-form-item>
            <el-form-item label="业务对接人邮箱：" prop="femail"><el-input type="text" v-model="account.femail" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="验证码：" prop="smsCode"><el-input type="text" v-model="account.smsCode" :maxlength="6" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="登录密码：" prop="fpassword"><el-input type="password" v-model="account.fpassword" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="确认密码：" prop="fpassword2"><el-input type="password" v-model="account.fpassword2" auto-complete="off"></el-input></el-form-item>
        </el-form>
        <div class="text-center">
            <el-button type="primary" @click="next">下一步</el-button>
        </div>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions } from 'vuex'
    import apis from '@/store/apis'
    import { accountRules } from '@/util/rules'

    export default {
        name: 'register-account',
        data () {
            return {
                rules: Object.assign({fpassword2: [
                    { required: true, message: '请再次输入密码', trigger: 'blur'},
                    { validator: this.validatePass, trigger: 'blur' }
                ],
                    fphone: [
                    { required: true, message: '请输入手机号'},
                    { validator: this.validatePhone, trigger: 'blur'}
    ]
                }, accountRules),
                countDown: '发送验证码'
            }
        },
        computed: mapGetters(['account']),
        methods: {
            ...mapActions(['submitAccount', 'goStep']),
            checkLoginName (rule, value, callback) { // 检查登录名称
                apis.checkLoginName(value).then((res) => {
                    if (res.data.result) {
                        callback()
                    } else {
                        callback(new Error(res.data.message))
                    }
                }, e => this.$alert(e))
            },
            validatePass (rule, value, callback) {
                if (value === '') {
                    callback(new Error('请再次输入密码'))
                } else if (value !== this.account.fpassword) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            },
            validatePhone (rule, value, callback) {
                if (/^1[3-9]\d{9}$/.test(value)) {
                    // apis.checkPhone(value).then((res) =>{
                    //     if (res.data.result) {
                    //         callback()
                    //     } else {
                    //         callback(new Error(res.data.message))
                    //     }
                    // }, e => {
                    //     callback()
                    // })
                    apis.checkJoinPhone(value).then((res) => {
                        if (res.data.result) {
                            callback()
                        } else {
                            callback(new Error(res.data.message))
                        }
                    }, e => {
                        callback(new Error('手机号码不正确'))
                    })
                } else {
                    callback(new Error('手机号码不正确'))
                }
            },
            validateCode (rule, value, callback) {
                if (this.account.fphone) {
                    apis.checkPhoneCode(this.account.fphone, value).then((res) => {
                        if (res.data.result) {
                            callback()
                        } else {
                            callback(new Error(res.data.message))
                        }
                    }, e => {
                        callback(new Error('验证码不正确'))
                    })
                } else {
                    this.$refs.accountForm.validateField('fphone')
                }
            },
            sendCode () {
                this.$refs.accountForm.validateField('fphone', message => {
                    if (!message) {
                        apis.getSmsCode(this.account.fphone).then(() => {
                            if (typeof this.countDown !== 'number') {
                                this.countDown = 30
                                let timer = window.setInterval(() => {
                                    if (this.countDown) {
                                        this.countDown--
                                    } else {
                                        this.countDown = '发送验证码'
                                        window.clearInterval(timer)
                                    }
                                }, 1000)
                            }
                        }).catch(err => {
                            this.$alert(err)
                        })
                    }
                })
            },
            next () {
                this.$refs['accountForm'].validate((valid) => {
                    if (valid) {
                        this.submitAccount()
                        this.goStep(1)
                        this.$router.push({ path: '/register/next'})
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }
        },
        mounted () {
            window.bob = this
            this.goStep(0)
            this.rules.smsCode.push({ validator: this.validateCode, trigger: 'blur'})
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.supplier-form{
    width: 100%;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/dsp/register/Account.vue